import { render, staticRenderFns } from "./WidgetContent.vue?vue&type=template&id=01acfc2e&scoped=true"
import script from "./WidgetContent.vue?vue&type=script&lang=js"
export * from "./WidgetContent.vue?vue&type=script&lang=js"
import style0 from "./WidgetContent.vue?vue&type=style&index=0&id=01acfc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01acfc2e",
  null
  
)

export default component.exports